export default {"src":"/_next/static/media/left_connector_horizontal.f75ead83.svg","height":2,"width":12,"blurWidth":0,"blurHeight":0};